<template>
  <div class="input-field autoc" v-if="isReady">
    <input @focus="$_showMeList()" autocomplete="off" v-model="text" type="text"  class="autocomplete"   ref="element"> 
     <label for="autocomplete"><slot></slot></label>
  </div>
</template>
<script>
import core from '@/functions'
export default {
  name:'autoComplete',
  props:{
    listKey:{
      type:String,
    },
    defaultText:{
      type:String,
    },
    isReady:{
      type:Boolean,
      default:true,
    },
    listData:{
      type:[Array],
      default(){
        return []
      }
    }
  },
  data(){
    let vm = this
    return {
      text:vm.defaultText,
      element:{
        instance:null,
        options:{
          limit:3,
          minLength:0,
          data:{},
          onAutocomplete:(e)=>{
            vm.$refs.element.value = e
            vm.text = e
            let match = vm.listData.find(active => active[this.listKey].toLowerCase() === e.toLowerCase())
            vm.$emit('update',match)
          }
        }
      }
    }
  },
  mounted(){
   this.defaultText !== '' 
    ? core.updateFields()
    :''
  },
  computed:{
    filterData:{
      get(){
        const goodData = (arr) =>{
          let data = {}
          arr.forEach(item=> data[item[this.listKey]] = '') //JSON.stringify(item)
          return data
        }
        return goodData(this.listData)
      }
    }
  },
  methods:{
    $_initElement(){
    this.element.instance = core.initAutoComplete(this.$refs.element, this.element.options)
    this.element.instance.updateData(this.filterData);
    this.$_showMeList()
    },
    $_showMeList(){
      if(this.element.instance === null) {
        this.$_initElement()
      }
      else {
     // if(this.text.toString().length === 0) this.$refs.element.value = ' '
        //setTimeout(() => {this.element.instance.open()  }, 500)
      }
    }
  }
}
</script>
<style  lang="scss">
.autoc {
  ul {
    &.dropdown-content {
      li span{
        font-size:13.5px !important
      }
    }
  }
}
</style>